import React from 'react';
import './SelectEquipment.css';

export default function EquipmentCustomSelect({
  selectList,
  selectedValue,
  setSelectedValue,
}) {
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className="form-select">
      <select
        id="equipment"
        className="select-equipment-field"
        value={selectedValue}
        onChange={handleChange}
      >
        <option value="" disabled>
          Odaberi opciju
        </option>
        {Object.keys(selectList).map((key) => (
          <option key={key} value={selectList[key].id}>
            {selectList[key].name}
          </option>
        ))}
      </select>
    </div>
  );
}
